import { CONTACT_ANSWER_PHONE_SUFFIX, SUPPORT_EMAIL, SUPPORT_EMAIL_HREF } from "./contact";
import { EXPORT_TIER, PRODUCTION_FACILITY, SEAT_TIER } from "./packaging";
import { ANNUAL_DISCOUNT_ANSWER } from "./pricing";
import { link, type Copy } from "./types";
import { type FaqEntry } from "./faq";

export const PRICING_FAQ_LABEL = "Pricing questions";

const seatContents: Copy = [
  `The software, embedded knit expertise, and access to production at ${PRODUCTION_FACILITY}. You design in the browser and LOOP generates the knitting logic and knit-ready machine data; physical prototypes are then validated through production.`,
];

export const PRICING_FAQ: readonly FaqEntry[] = [
  {
    id: "annual-discount",
    question: ["How does the annual discount work?"],
    answer: [ANNUAL_DISCOUNT_ANSWER],
  },
  {
    id: "seat-contents",
    question: ["What's actually included in a seat?"],
    answer: seatContents,
  },
  {
    id: "export-tier",
    question: [`Which plans include machine file export?`],
    answer: [
      `LOOP generates knit-ready machine data on every plan. Exporting starts on a ${SEAT_TIER} Seat for teams running LOOP alongside their own or partnering factories, with onboarding for machine capability and testing data. Physical output still needs prototyping and validation for yarn, machine setup, finishing and quality control.`,
    ],
  },
  {
    id: "seat-changes",
    question: ["Can we add or remove seats later?"],
    answer: [
      "Yes. Email ",
      link(SUPPORT_EMAIL, SUPPORT_EMAIL_HREF),
      ` and we'll adjust the account. ${EXPORT_TIER} agreements carry volume terms on seat count — talk to us about where your team is heading.`,
    ],
  },
  {
    id: "contact",
    question: ["Who do I contact with questions?"],
    answer: ["Email ", link(SUPPORT_EMAIL, SUPPORT_EMAIL_HREF), CONTACT_ANSWER_PHONE_SUFFIX],
  },
];
